module.exports = __webpack_public_path__ + "img/contentsBellIcon.21b0b51f.svg";